// import LocationListDropdown from 'component/LocationListDropdown'
// import ProfileButton from './profile-button'
// import { useOperator } from 'context/operator'
// import { useState } from 'react'
// import { Copy, Check, Info, Download } from 'lucide-react'
// import QRCodeCanvas from 'screens/admin/Vehicles/components/ControlTabs/QRCodeCanvas'

// function TopHeader() {
//   const {operator} = useOperator()
//   const [copied, setCopied] = useState(false)

//   const handleCopy = () => {
//     if (operator?._id) {
//       navigator.clipboard.writeText(operator._id)
//       setCopied(true)
//       setTimeout(() => setCopied(false), 2000)
//     }
//   }

//   const downloadQR = () => {
//     const canvas = document
//       .getElementById('qrcode-container')
//       .querySelector('canvas')
//     if (!canvas) return
//     const pngUrl = canvas
//       .toDataURL('image/png')
//       .replace('image/png', 'image/octet-stream')
//     let downloadLink = document.createElement('a')
//     downloadLink.href = pngUrl
//     downloadLink.download = `operator-${operator?._id || 'qr'}-qrcode.png`
//     document.body.appendChild(downloadLink)
//     downloadLink.click()
//     document.body.removeChild(downloadLink)
//   }

//   return (
//     <>
//     <div className="flex items-center gap-3">
//       <div className='flex items-center gap-3 bg-white px-3 py-1.5 rounded-xl shadow-sm border border-gray-100'>
        
//         {/* Left Side: QR & Download */}
//         <div className='flex items-center gap-2 border-r border-gray-100 pr-3'>
//           <div id='qrcode-container' className='w-8 h-8 flex items-center justify-center bg-gray-50 rounded overflow-hidden p-0.5 border border-gray-100'>
//             {operator?._id && (
//               <QRCodeCanvas value={operator._id} size={512} style={{ width: '100%', height: '100%' }} />
//             )}
//           </div>
//           <button
//             onClick={downloadQR}
//             className='flex items-center justify-center p-1.5 text-gray-400 hover:text-[#BA141B] hover:bg-red-50 rounded-lg transition-all'
//             title='Download QR Code'
//           >
//             <Download className='w-4 h-4' />
//           </button>
//         </div>

//         {/* Right Side: Business ID */}
//         <div className='flex items-center gap-2 text-[12px] text-gray-500'>
//           <span className='font-bold uppercase tracking-[0.2em] text-[8px] text-gray-400'>Business ID</span>
//           <div className='flex items-center gap-1 bg-gray-50 pl-2 pr-1 py-1 rounded border border-gray-100'>
//             <code className='font-mono text-gray-600 font-medium text-[11px]'>{operator?._id}</code>
//             <button
//               onClick={handleCopy}
//               className='p-1 hover:bg-gray-200 rounded transition-colors ml-1'
//               title='Copy Business ID'
//             >
//               {copied ? (
//                 <Check className='w-3 h-3 text-green-600' />
//               ) : (
//                 <Copy className='w-3 h-3 text-gray-400' />
//               )}
//             </button>
//             <div className='group/info relative flex flex-col items-center ml-0.5'>
//               <Info className='w-3 h-3 text-gray-400 cursor-help hover:text-[#BA141B] transition-colors' />
//               <div className='absolute left-1/2 top-full mt-2 -translate-x-1/2 w-48 p-2 bg-gray-900 text-white text-[10px] leading-tight rounded-lg opacity-0 invisible group-hover/info:opacity-100 group-hover/info:visible transition-all z-50 pointer-events-none shadow-xl font-normal text-center'>
//                 Provide this to your customer to use on signup
//                 <div className='absolute left-1/2 bottom-full -mt-2 -ml-1 border-4 border-transparent border-b-gray-900'></div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
      
//       {copied && (
//         <span className='text-[9px] text-green-600 font-black uppercase tracking-[0.2em] animate-pulse whitespace-nowrap'>
//           Copied!
//         </span>
//       )}
//     </div>
//     <div className="flex items-center justify-end w-full">
//       <div className="flex items-center gap-4 md:gap-6">
//         {/* Location selector - hidden on mobile by default */}
//         {/* <div className="hidden md:block">
//           <LocationListDropdown />
//         </div> */}

//         {/* Profile button */}
//         <ProfileButton />
//       </div>
//     </div>
//     </>

//   )
// }

// export default TopHeader

import LocationListDropdown from 'component/LocationListDropdown'
import ProfileButton from './profile-button'
import { useOperator } from 'context/operator'
import { useState, useMemo } from 'react'
import { Copy, Check, Info, Download } from 'lucide-react'
import QRCodeCanvas from 'screens/admin/Vehicles/components/ControlTabs/QRCodeCanvas'

function TopHeader() {
  const { operator } = useOperator()
  const [copied, setCopied] = useState(false)

  const operatorId = operator?._id || ''

  const signupDeepLink = useMemo(() => {
    if (!operatorId) return ''
    return `tourdec://SignUpScreen?operatorId=${encodeURIComponent(operatorId)}`
  }, [operatorId])

  const handleCopy = () => {
    if (operatorId) {
      navigator.clipboard.writeText(operatorId)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    }
  }

  const downloadQR = () => {
    const container = document.getElementById('qrcode-container')
    const canvas = container?.querySelector('canvas')

    if (!canvas) return

    const pngUrl = canvas
      .toDataURL('image/png')
      .replace('image/png', 'image/octet-stream')

    const downloadLink = document.createElement('a')
    downloadLink.href = pngUrl
    downloadLink.download = `operator-${operatorId || 'qr'}-qrcode.png`
    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)
  }

  return (
    <>
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-3 bg-white px-3 py-1.5 rounded-xl shadow-sm border border-gray-100">
          
          {/* Left Side: QR & Download */}
          <div className="flex items-center gap-2 border-r border-gray-100 pr-3">
            <div
              id="qrcode-container"
              className="w-8 h-8 flex items-center justify-center bg-gray-50 rounded overflow-hidden p-0.5 border border-gray-100"
            >
              {signupDeepLink && (
                <QRCodeCanvas
                  value={signupDeepLink}
                  size={512}
                  style={{ width: '100%', height: '100%' }}
                />
              )}
            </div>
            <button
              onClick={downloadQR}
              className="flex items-center justify-center p-1.5 text-gray-400 hover:text-[#BA141B] hover:bg-red-50 rounded-lg transition-all"
              title="Download QR Code"
            >
              <Download className="w-4 h-4" />
            </button>
          </div>

          {/* Right Side: Business ID */}
          <div className="flex items-center gap-2 text-[12px] text-gray-500">
            <span className="font-bold uppercase tracking-[0.2em] text-[8px] text-gray-400">
              Business ID
            </span>
            <div className="flex items-center gap-1 bg-gray-50 pl-2 pr-1 py-1 rounded border border-gray-100">
              <code className="font-mono text-gray-600 font-medium text-[11px]">
                {operatorId}
              </code>
              <button
                onClick={handleCopy}
                className="p-1 hover:bg-gray-200 rounded transition-colors ml-1"
                title="Copy Business ID"
              >
                {copied ? (
                  <Check className="w-3 h-3 text-green-600" />
                ) : (
                  <Copy className="w-3 h-3 text-gray-400" />
                )}
              </button>
              <div className="group/info relative flex flex-col items-center ml-0.5">
                <Info className="w-3 h-3 text-gray-400 cursor-help hover:text-[#BA141B] transition-colors" />
                <div className="absolute left-1/2 top-full mt-2 -translate-x-1/2 w-48 p-2 bg-gray-900 text-white text-[10px] leading-tight rounded-lg opacity-0 invisible group-hover/info:opacity-100 group-hover/info:visible transition-all z-50 pointer-events-none shadow-xl font-normal text-center">
                  Provide this to your customer to use on signup
                  <div className="absolute left-1/2 bottom-full -mt-2 -ml-1 border-4 border-transparent border-b-gray-900"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {copied && (
          <span className="text-[9px] text-green-600 font-black uppercase tracking-[0.2em] animate-pulse whitespace-nowrap">
            Copied!
          </span>
        )}
      </div>
      <div className="flex items-center justify-end w-full">
        <div className="flex items-center gap-4 md:gap-6">
          {/* Location selector - hidden on mobile by default */}
          {/* <div className="hidden md:block">
            <LocationListDropdown />
          </div> */}

          {/* Profile button */}
          <ProfileButton />
        </div>
      </div>
    </>
  )
}

export default TopHeader